import { Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import TopHeader from "./components/TopHeader";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import RoadTransport from "./pages/RoadTransport";
import TransportSimulation from "./pages/TransportSimulation";
import OptimalRoute from "./pages/OptimalRoute";

function App() {
  return (
    <>
      <TopHeader> </TopHeader>
      <NavBar></NavBar>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/RoadTransport" element={<RoadTransport />}></Route>
        <Route path="/Simulation" element={<TransportSimulation />}></Route>
        <Route path="/OptimalRoute" element={<OptimalRoute />}></Route>
      </Routes>
      <Footer></Footer>
    </>
  );
}

export default App;
